import React, { useState, useEffect } from "react";
import axios from "axios";
import { uri } from "../../../../help/Api";
import Grid from "@material-ui/core/Grid";
import ButtonBase from "@material-ui/core/ButtonBase";
import { useInvAF, useInvMain } from "../../../../St/Reviews/UseStyle";
import { sto } from "../../../../Context/InshData";
import { useBody,useHeader } from "../../invCompany/style";

function HeaderM({foundData}) {
  const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

  // const clasH = useInvHeadrAF();
  const classHeader = useHeader();
  const styleBo={
    border: "solid 1px",
    borderRadius: "7px",
    fontWeight: "500",
    padding:6,
  };
  const styleNo={
    borderRadius: "7px",
    fontWeight: "500",
    padding:6,
  };
  const styfull = { fontWeight: "bold" };
  const styf = { fontWeight: "500" };

  const styfC = { fontWeight: "500", color: "#9a3f47" };

  const clasm = useInvMain();
  const clas = useInvAF();
  const calssBody = useBody();
  return (
    <>
     { foundData.header_img != null  ? (
              (
              <Grid item xs={12} justifyContent="center" style={{ minWidth: "20cm", maxWidth: "20cm", minHeight: "3.6cm", maxHeight: "3.6cm", paddingBottom: "0.2cm", paddingTop: "0.1cm" }}>
               <div>
                 <ButtonBase>
                   {" "}
                   <img
                     src={`data:image/jpeg;base64,${foundData.header_img}`}
                     className={clas.headerImg}
                     alt={foundData.nameA}
                   />{" "}
                 </ButtonBase>
               </div>
             </Grid>
             )
         )  :
         (
          <Grid
          item
          container
          justifyContent="center"
          style={{ paddingTop:"0.5rem", fontWeight: "bold",fontFamily: "Amiri-Regular", 
          }}
        >
          <Grid       item
          xs={12}
          
          style={premiApp.billTemplate !== 9?styleBo:styleNo}
          >
            <Grid item container >
          <Grid item xs={5} className={clasm.minleft}>
            <div style={styfull}>{foundData.Disc1_header_en}</div>
            <div style={styfull}>{foundData.Disc2_header_en}</div>
            <div style={styfull}>{foundData.Disc3_header_en}</div>{" "}
            <div style={styfull}>{foundData.Disc4_header_en}</div>
          </Grid>
    
          <Grid item xs={2} className={clasm.mincntr}>
            <div>
              <ButtonBase>
                {" "}
                <img
                  src={`data:image/jpeg;base64,${foundData.Logo}`}
                  className={clas.Hedlogo}
                  alt={foundData.nameA}
                />{" "}
              </ButtonBase>
            </div>
          </Grid>
    
          <Grid item xs={5} className={clasm.minrit}>
            <div style={styfull}>{foundData.Disc1_header_ar}</div>{" "}
            <div style={styfull}>{foundData.Disc2_header_ar}</div>
            <div style={styfull}>{foundData.Disc3_header_ar}</div>{" "}
            <div style={styfull}>{foundData.Disc4_header_ar}</div>
          </Grid>
          </Grid>
          </Grid>
        </Grid>
         )}

    </>
  );
}
export default HeaderM;
